<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="col-lg-12">
              <div v-if="items.length > 0" class="col-lg-2 ml-auto p-0">
                <select
                  class="form-control"
                  v-model="filterBy"
                  v-on:change="change"
                >
                  <option value="">Select Sort</option>
                  <option value="newest" :selected="filterBy === 'newest'">
                    Newest First
                  </option>
                  <option value="oldest" :selected="filterBy === 'oldest'">
                    Oldest First
                  </option>
                  <option value="az" :selected="filterBy === 'az'">A-Z</option>
                  <option value="za" :selected="filterBy === 'za'">Z-A</option>
                </select>
              </div>

              <div class="section-items">
                <div v-if="loader">
                  <img
                    slot="preloader"
                    v-bind:src="`${IMAGEURL}/assets/img/loader.gif`"
                    title="Loading..."
                  />
                </div>
                <div v-if="!loader && items.length < 1">No data found.</div>

                <div class="list-group mb-3">
                  <a v-for="(item, key) in items" v-bind:key="key" target="_blank" :href="`${IMAGEURL}${item.image}`" class="list-group-item list-group-item-action">
                    {{ item.title }}
                    <span class="float-right"
                        ><i class="fa fa-file-pdf-o"></i> Download</span
                      >
                  </a>
                </div>
              </div>

              <nav v-if="items.length > 0" class="d-flex justify-content-center">
                <ul class="pagination">
                  <li
                    v-for="(item, k) in links"
                    :key="k"
                    :class="getPagingClass(item)"
                  >
                    <a
                      class="page-link"
                      @click="getData(item.url)"
                      href="javascript:;"
                      v-html="getPagingLabel(item)"
                    ></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import Pagination from "vue-and-pagination";

export default {
  name: `JobCircular`,
  data() {
    return {
      loader: true,
      links: null,
      filterBy: this.$route.query.sort ? this.$route.query.sort : "",
      breadType: "",
      items: "",
      orderBy: "",
    };
  },
  components: {
    Layout,
    "vue-load-image": VueLoadImage,
    Pagination,
  },
  methods: {
    change() {
      let url = this.$helper.UrlGenerate("sort", this.filterBy);
      window.location.href = url;
    },
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    getData(url, sortBy) {
      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          this.items = json.data;
          this.loader = false;
          console.log(json);
          this.links = json.links;
          $(".back-to-top").trigger("click");
        });
    },
  },
  mounted() {
    let url = this.APIURL + "job-circular?sort=" + this.filterBy;
    this.getData(url, this.filterBy);
  },
};
</script>
